<template>
    <footer>
        <div class="contact" v-if="showConsult">
            <h5>联系我们</h5>
            <p>{{ websitConfig.websiteNames }}</p>
            <p>{{ websitConfig.companyName }}</p>
            <p>电话: {{ websitConfig.companyPhone }}</p>
            <p>邮箱: {{ websitConfig.companyEmail }}</p>
            <p>地址: {{ websitConfig.companyAddress }}</p>
        </div>
        <ul class="codes">
            <li :class="{ active: showCodeIndex == 0 }" @click.stop="showCodeIndex = 0">
                <img src="@/assets/imgs/icon14.png" alt="">
                <img :src="setting.officialCode" alt="" class="code" v-if="showCodeIndex == 0">
            </li>
            <li :class="{ active: showCodeIndex == 1 }" @click.stop="showCodeIndex = 1">
                <img src="@/assets/imgs/icon13.png" alt="">
                <img :src="setting.channelCode" alt="" class="code" v-if="showCodeIndex == 1">
            </li>
            <li :class="{ active: showCodeIndex == 2 }" @click.stop="showCodeIndex = 2">
                <img src="@/assets/imgs/icon10.png" alt="">
                <img :src="setting.wxCode" alt="" class="code" v-if="showCodeIndex == 2">
            </li>
            <li :class="{ active: showCodeIndex == 3 }" @click.stop="showCodeIndex = 3">
                <img src="@/assets/imgs/icon12.png" alt="">
                <img :src="setting.douyinCode" alt="" class="code" v-if="showCodeIndex == 3">
            </li>
        </ul>
        <div class="copyright">
            Copyright © 2025 东方金典数字科技（湖南）有限公司版权所有   湘ICP备16014xxxxxxxx号-1
        </div>
    </footer>
</template>
<script setup>
import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import * as api from '@/request/front'
const props = defineProps({
    showConsult: {
        type: Boolean,
        default: true
    }
})
const store = useStore()
const showCodeIndex = ref(-1)
const setting = computed(() => store.state.front.websitConfig)
const websitConfig = computed(() => store.state.front.websitConfig)
onMounted(() => {
    document.addEventListener('click', () => {
        showCodeIndex.value = -1
    })
})
</script>
<style scoped lang="scss">
footer {
    background-color: #000;
    padding-top: 10rem;

    * {
        color: #FFF;
    }

    p {
        color: #96969F;
    }
}

.codes {
    padding: 20rem;
    margin-top: 10rem;
    display: flex;
    justify-content: space-around;

    li {
        width: 50rem;
        height: 50rem;
        background: transparent;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10rem;
        border: 1px solid #2B2B2F;
        box-shadow: inset 0 0 8rem rgba(255, 255, 255, 0.5);
        img {
            width: 27rem;
            height: auto;
        }

        .code {
            position: absolute;
            bottom: 50rem;
            left: -25rem;
            width: 90rem;
            height: 90rem;
        }
    }

    .active {
        background-color: #000;
    }
}

.contact {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 50rem;
    h5 {
        text-align: center;
        font-size: 16rem;
        line-height: 30rem;
        width: 80%;
    }

    p {
        text-align: center;
        line-height: 24rem;
        line-height: 30rem;

        width: 70%;
    }
}
.copyright{
    text-align: center; font-size: 9rem; border-top: 1px solid #2B2B2F; padding: 10rem 0; color: #96969F;
}
</style>